import "dayjs/locale/ja";
import { useSelector } from "react-redux";
import { RootState } from "../../store/types";
import { useNavigate } from "react-router-dom";
import SerialBoard from "../ServiceCenter/SerialBoard";

const CompanyHome = () => {
    const { loggedInUser } = useSelector((state: RootState) => state.global);
    const navigate = useNavigate();

    return (<>
        {loggedInUser?.currentCompany && <h2 className="mt-0" style={{ fontVariantCaps: "small-caps" }}>
            {loggedInUser?.currentCompany?.name}
        </h2>}
        <SerialBoard />
    </>
    );
};

export default CompanyHome;
